module.exports = __webpack_public_path__ + "static/media/my.c1a24e8d.svg";